import { apiUrl } from "../../features/Constants"
export const ns = "importLearner"
export const IMPORT_URL = `${apiUrl}/universe/import/user`
export const source = "learners"
